import {
  CREATE_ADMIN_NOTIFICATION_TEMPLATE,
  CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  GET_ADMIN_NOTIFICATION_TEMPLATES,
  GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS,
  GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR,
  UPDATE_ADMIN_USER_NOTIFICATIONS,
  UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR,

} from "./actionTypes"

const initialState = {
  error: {},
  admin_notification_templates: [],
  admin_notifications: [],
  loading: null,
  admin_notification_template_create_update_loading:null,
  admin_notification_templates_loading: null,
}

const AdminNotifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_NOTIFICATION_TEMPLATES:
      return {
        ...state,
        admin_notification_templates_loading: true
      }
    case GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS:
      return {
        ...state,
        admin_notification_templates: action.payload,
        admin_notification_templates_loading: false,
        error: null,
      }

    case GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR:
      return {
        ...state,
        admin_notification_templates_loading: false,
        error: action.payload,
      }
    case CREATE_ADMIN_NOTIFICATION_TEMPLATE:
      return {
        ...state,
        admin_notification_template_create_update_loading: true,
      }
    case CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS:
      return {
        ...state,
        admin_notification_templates: [...state.admin_notification_templates, action.payload],
        admin_notification_template_create_update_loading: false,
      }
    case CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR:
      return {
        ...state,
        error: action.payload,
        admin_notification_template_create_update_loading: false,
      }
    case UPDATE_ADMIN_NOTIFICATION_TEMPLATE:
      return {
        ...state,
        admin_notification_template_create_update_loading: true,
      }
    case UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS:
      return {
        ...state,
        admin_notification_templates: state.admin_notification_templates.map(template => {
          if (template.id === action.payload.id) {
            return action.payload
          }
          return template
        }),
        admin_notification_template_create_update_loading: false,
      }
    case UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR:
      return {
        ...state,
        error: action.payload,
        admin_notification_template_create_update_loading: false,
      }
    case DELETE_ADMIN_NOTIFICATION_TEMPLATE:
      return {
        ...state,
      }
    case DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS:
      return {
        ...state,
        admin_notification_templates: state.admin_notification_templates.filter(template => template.id !== action.payload.id),
      }
    case DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ADMIN_USER_NOTIFICATION_PREFERENCES:
      return {
        ...state,
      }
    case GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS:
      return {
        ...state,
        admin_notifications: action.payload,
      }
    case GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR:
      return {
        ...state,
        error: action.payload,
        admin_notifications: [],
      }
    case UPDATE_ADMIN_USER_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        admin_notifications: action.payload,
        loading: false,
      }
    case UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default AdminNotifications
